import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';
import { SystemmenuService, SystemModule } from '../../services/systemmenu.service';
import { Configuration } from '../../../app.constants';
import * as events from 'devextreme/events';
import { Routes, RouterModule } from '@angular/router';
import{StudentportalComponent} from'./../../../studentportal/studentportal.component';
import {ProfilepreviousComponent} from "./../../../studentportal/components/profile/profileprevious.component";
import {Router, ActivatedRoute} from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

/* const routes: Routes = [];
@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
exports: [ RouterModule ]
})
 */
@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})

export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent)
  menu: DxTreeViewComponent;
  @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
  
  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  @Input()
  items: any[];
  
  List1: any;

  @Input()
  set selectedItem(value: String) {
    if (this.menu.instance) {
      this.menu.instance.selectItem(value);
    }
  }

  private _compactMode = false;
  menuId: number;
  submenupath:string;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;
    if (val && this.menu.instance) {
      this.menu.instance.collapseAll();
    }
  }
  menuItems: any[] = [];

  constructor(private Router:Router,private elementRef: ElementRef, private systemMenuService: SystemmenuService, private configuration: Configuration) {
    this.getSystemMenu();
  }

  getSystemMenu() {debugger
    if(this.configuration.IsParrent==false)
    {
      this.systemMenuService.GetUserGroupIDforPortal()
      .subscribe((data:SystemModule[]) => this.List1 = data,
      error => {debugger
      alert(error);
        },
        () => {
          debugger; 
          if(this.List1.length>0){
            this.configuration.SysUsrGrpID=this.List1[0].SysUsrGrpID;
           
              this.menuId = 0;
              this.systemMenuService.getAllMenuByGroupId(this.configuration.SysUsrGrpID,this.configuration.SelectedLanguage).subscribe(
                (data: SystemModule[]) => {
        
                  for (var i = 0; i < data.length; i++) {
        
                    var module = {
                      id: 0,
                      text: '',
                      path: '',
                      icon: '',
                      items: []
                    }
                    this.menuId = this.menuId + 1;
                  var sysModueData = data[i];
                      module.icon = '';
                    module.path = "/";
                    module.text = sysModueData.SysModName;
                    module.id = this.menuId; //sysModueData.SysModID;
                    if ((sysModueData.SysSubModList)) {
        
                      for (var p = 0; p < sysModueData.SysSubModList.length; p++) {
                        var item = {
                          id: 0,
                          text: '',
                          path: '',
                          icon: '',
                          items: [],
                          SysSubModID:0,
                          Instruction:'',
                          InStructionInDevnagri:'',
                        }
        
                        this.menuId = this.menuId + 1;
                        var programModule = sysModueData.SysSubModList[p];
                        item.icon = programModule.SubModuleImageClass,
                        item.path = programModule.SysSubModShrtName;
                        item.text = programModule.SysSubModName;
                        item.id = this.menuId; 
                        item.SysSubModID=programModule.SysSubModID;//programModule.SysSubModID;
                        if ((programModule.SysProgList) && (programModule.SysProgList.length > 0)) {
                          for (var x = 0; x < programModule.SysProgList.length; x++) {
                            
  
                            var programItem = {
                              id: 0,
                              text: '',
                              path: '',
                              icon: '',
                              AccessPath:'',
                              SysSubModID:0,
                              Instruction:'',
                              InStructionInDevnagri:'',
                            }
                            this.menuId = this.menuId + 1;
                            var systemProgram = programModule.SysProgList[x];
                            // need to check PrgImgClass
                            // if(systemProgram.PrgImgClass)
                            // {
                            //   programItem.icon = systemProgram.PrgImgClass != null ? systemProgram.PrgImgClass : '';
                            // }
                            // else{
                            //     programItem.icon ='';
                            // }
                            if(systemProgram.GridFormToOpen!="courseselectionprospectus" && systemProgram.GridFormToOpen!="checklist-registration-info" && systemProgram.GridFormToOpen!="registrationform"){
                              programItem.path = "/"+ item.path+"/"+systemProgram.GridFormToOpen;
                              programItem.text = systemProgram.SysProgName;
                              programItem.id = this.menuId;
                              programItem.AccessPath=systemProgram.GridFormToOpen;
                              programItem.icon=systemProgram.PrgImgClass// systemProgram.SysProgID;
                              programItem.SysSubModID=0;
                              programItem.Instruction=systemProgram.Instruction;
                              programItem.InStructionInDevnagri=systemProgram.InStructionInDevnagri;
                              item.items.push(programItem);
                            }
                          }
                        }
                        module.items.push(item);
                      }
                      debugger;
                      this.configuration.progoramlist = module.items;
                        
                      this.menuItems.push(module);
                    }
                  }
                },
                error => {
                  alert(error);
                },
                () => {
                });
            
          }
  
                
        }); 
    }else{
      this.systemMenuService.GetUserGroupIDforParentPortal()
    .subscribe((data:SystemModule[]) => this.List1 = data,
    error => {
    alert(error);
      },
      () => {
        debugger; 
        if(this.List1.length>0){
          this.configuration.SysUsrGrpID=this.List1[0].SysUsrGrpID;
         
            this.menuId = 0;
            this.systemMenuService.getAllParentMenuByGroupId(this.configuration.SysUsrGrpID,this.configuration.SelectedLanguage).subscribe(
              (data: SystemModule[]) => {
      
                for (var i = 0; i < data.length; i++) {
      
                  var module = {
                    id: 0,
                    text: '',
                    path: '',
                    icon: '',
                    items: []
                  }
                  this.menuId = this.menuId + 1;
                var sysModueData = data[i];
                    module.icon = '';
                  module.path = "/";
                  module.text = sysModueData.SysModName;
                  module.id = this.menuId; //sysModueData.SysModID;
                  if ((sysModueData.SysSubModList)) {
      
                    for (var p = 0; p < sysModueData.SysSubModList.length; p++) {
                      var item = {
                        id: 0,
                        text: '',
                        path: '',
                        icon: '',
                        items: [],
                        SysSubModID:0,
                        Instruction:'',
                        InStructionInDevnagri:'',
                      }
      
                      this.menuId = this.menuId + 1;
                      var programModule = sysModueData.SysSubModList[p];
                      item.icon = programModule.SubModuleImageClass,
                      item.path = programModule.SysSubModShrtName;
                      item.text = programModule.SysSubModName;
                      item.id = this.menuId; 
                      item.SysSubModID=programModule.SysSubModID;//programModule.SysSubModID;
                      if ((programModule.SysProgList) && (programModule.SysProgList.length > 0)) {
                        for (var x = 0; x < programModule.SysProgList.length; x++) {
                          

                          var programItem = {
                            id: 0,
                            text: '',
                            path: '',
                            icon: '',
                            AccessPath:'',
                            SysSubModID:0,
                            Instruction:'',
                            InStructionInDevnagri:'',
                          }
                          this.menuId = this.menuId + 1;
                          var systemProgram = programModule.SysProgList[x];
                          // need to check PrgImgClass
                          // if(systemProgram.PrgImgClass)
                          // {
                          //   programItem.icon = systemProgram.PrgImgClass != null ? systemProgram.PrgImgClass : '';
                          // }
                          // else{
                          //     programItem.icon ='';
                          // }
                          if(systemProgram.GridFormToOpen!="courseselectionprospectus" && systemProgram.GridFormToOpen!="checklist-registration-info" && systemProgram.GridFormToOpen!="registrationform"){
                            programItem.path = "/"+ item.path+"/"+systemProgram.GridFormToOpen;
                            programItem.text = systemProgram.SysProgName;
                            programItem.id = this.menuId;
                            programItem.AccessPath=systemProgram.GridFormToOpen;
                            programItem.icon=systemProgram.PrgImgClass// systemProgram.SysProgID;
                            programItem.SysSubModID=0;
                            programItem.Instruction=systemProgram.Instruction;
                            programItem.InStructionInDevnagri=systemProgram.InStructionInDevnagri;
                            item.items.push(programItem);
                          }
                        }
                      }
                      module.items.push(item);
                    }
                    debugger;
                    this.configuration.progoramlist = module.items;
                      
                    this.menuItems.push(module);
                  }
                }
              },
              error => {
                alert(error);
              },
              () => {
              });
          
        }

              
      }); 
    }
    

   

  }

  updateSelection(event) {
    const nodeClass = 'dx-treeview-node';
    const selectedClass = 'dx-state-selected';
    const leafNodeClass = 'dx-treeview-node-is-leaf';
    const element: HTMLElement = event.element;
    this.menu.instance.expandItem(1);
    const rootNodes = element.querySelectorAll(`.${nodeClass}:not(.${leafNodeClass})`);
    Array.from(rootNodes).forEach(node => {
      node.classList.remove(selectedClass);
    });

    let selectedNode = element.querySelector(`.${nodeClass}.${selectedClass}`);
    while (selectedNode && selectedNode.parentElement) {
      if (selectedNode.classList.contains(nodeClass)) {
          selectedNode.classList.add(selectedClass);
      }

      selectedNode = selectedNode.parentElement;
    }
  }

  onItemClick(event) {debugger
    this.selectedItemChanged.emit(event);
    
    
  }

  onMenuInitialized(event) {
    event.component.option('deferRendering', false);
    this.menu.instance.expandItem(1);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.next(e);
      this.menu.instance.expandItem(1);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}

@NgModule({
  imports: [ DxTreeViewModule ],
  declarations: [ SideNavigationMenuComponent ],
  exports: [ SideNavigationMenuComponent ]
})
export class SideNavigationMenuModule { }
